import React, { useState } from "react";
import "./Login.css";
import axios from "axios";

function Login(props) {
  const [error, setError] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    dob: "",
    phone: "",
    designation: "",
    institution: "",
    city: "",
    country: "",
    type: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError("");
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleReg = async (e) => {
    e.preventDefault();
    if (
      !formData.email ||
      !formData.password ||
      !formData.firstName ||
      !formData.lastName
    ) {
      setError("Email, Password, First Name, and Last Name are required.");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords don't match");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/register`,
        {
          email: formData.email,
          password: formData.password,
          firstName: formData.firstName,
          lastName: formData.lastName,
          dob: formData.dob,
          phone: formData.phone,
          designation: formData.designation,
          institution: formData.institution,
          city: formData.city,
          country: formData.country,
          type: "",
        }
      );
      props.setUser(response.data.email);
      window.location.href = "/";
    } catch (error) {
      if (error.response) {
        setError(error.response.data.error);
      } else if (error.request) {
        setError(error.request);
      } else {
        setError(error.message);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          email: formData.email,
          password: formData.password,
        }
      );
      props.setUser(response.data.email);
      window.location.href = "/";
    } catch (error) {
      if (error.response) {
        setError(error.response.data.error);
      } else if (error.request) {
        setError(error.request);
      } else {
        setError(error.message);
      }
    }
  };

  return (
    <div className="login">
      <div className="login-card">
        {!showRegister ? (
          <>
            <div className="login-section">
              <h2 className="login-title">Login</h2>
              <form onSubmit={handleSubmit} className="login-form">
                <div className="input-group">
                  <label className="input-label" htmlFor="login-email">
                    Email
                  </label>
                  <input
                    id="login-email"
                    name="email"
                    type="email"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="login-password">
                    Password
                  </label>
                  <input
                    id="login-password"
                    name="password"
                    type="password"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <button type="submit" className="button-primary">
                  Submit
                </button>
                {error && <div className="error-message">{error}</div>}
              </form>
              <div className="link">
                <span onClick={() => setShowRegister(true)}>
                  Create an account
                </span>
              </div>
            </div>
          </>
        ) : (
          <div className="login-section">
            <h2 className="login-title">Register</h2>
            <form onSubmit={handleReg} className="login-form">
              <div className="input-groups-container">
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-email">
                    Email
                  </label>
                  <input
                    id="reg-email"
                    name="email"
                    type="email"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-first-name">
                    First Name
                  </label>
                  <input
                    id="reg-first-name"
                    name="firstName"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-password">
                    Password
                  </label>
                  <input
                    id="reg-password"
                    name="password"
                    type="password"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-last-name">
                    Last Name
                  </label>
                  <input
                    id="reg-last-name"
                    name="lastName"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-confirm-password">
                    Confirm Password
                  </label>
                  <input
                    id="reg-confirm-password"
                    name="confirmPassword"
                    type="password"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>

                <div className="input-group">
                  <label className="input-label" htmlFor="reg-dob">
                    Date of Birth (DD/MM/YYYY)
                  </label>
                  <input
                    id="reg-dob"
                    name="dob"
                    type="text"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-phone">
                    Phone Number
                  </label>
                  <input
                    id="reg-phone"
                    name="phone"
                    type="tel"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-designation">
                    Designation
                  </label>
                  <input
                    id="reg-designation"
                    name="designation"
                    type="text"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-institution">
                    Institution
                  </label>
                  <input
                    id="reg-institution"
                    name="institution"
                    type="text"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-city">
                    City
                  </label>
                  <input
                    id="reg-city"
                    name="city"
                    type="text"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label" htmlFor="reg-country">
                    Country
                  </label>
                  <input
                    id="reg-country"
                    name="country"
                    type="text"
                    onChange={handleChange}
                    className="input-field"
                  />
                </div>
              </div>
              <button type="submit" className="button-primary">
                Submit
              </button>
              {error && <div className="error-message">{error}</div>}
              <div className="link">
                <span onClick={() => setShowRegister(false)}>
                  Back to Login
                </span>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
